import { useQuery } from "@tanstack/react-query";
import { ApiServiceErr, axiosApi } from "./apiService";

interface GetDrawingChangesInput {
  from: string | null;
  to: string | null;
  sourceId: string;
  ownerId: string;
}

export const useGetDrawingChanges = (data: GetDrawingChangesInput) => {
  return useQuery<string[], ApiServiceErr>(
    ["getDrawingChanges", data],
    async () => {
      const response = await axiosApi.post("/change-history/drawing-changes", data);
      return response?.data;
    },
    {
      enabled: !!data?.from && !!data?.to && !!data?.sourceId && !!data?.ownerId
    }
  );
};
